__turbopack_context__.v({
  "benefitItem": "styles-module__rVHmAW__benefitItem",
  "benefitText": "styles-module__rVHmAW__benefitText",
  "benefitsList": "styles-module__rVHmAW__benefitsList",
  "iconWrapper": "styles-module__rVHmAW__iconWrapper",
  "rotate360": "styles-module__rVHmAW__rotate360",
  "section": "styles-module__rVHmAW__section",
  "stamp": "styles-module__rVHmAW__stamp",
  "stampContainer": "styles-module__rVHmAW__stampContainer",
});
